import { ISearchCustomerItem } from 'modules/customer/widgets/AddCustomer/type';
import { call, delay, put, select, takeLatest } from 'redux-saga/effects';
import { ISagaFunc } from 'services/actionConfigs';
import { IResponseData } from 'services/response';
import giftCardApis from './apis';
import { GetGiftCardListParams, } from './constants';
import { actions, selectors } from './slice';

const getGiftCardList: ISagaFunc<GetGiftCardListParams> = function* ({ payload }) {
  yield delay(200);
  const giftCardParams = yield select(selectors.getGiftCardParams);
  const _params = { ...giftCardParams, ...payload };
  if (!_params.keySearch || _params.keySearch == '') {
    delete _params.keySearch;
  }
  try {
    const response = yield call(giftCardApis.giftCard.getList, _params);
    yield put(actions.async.getGiftCardList.success(response.data.data));
  } catch (error) {
    yield put(actions.async.getGiftCardList.fail({}));
  }
};

const getGiftCardDetail: ISagaFunc<string> = function* ({ payload }) {
  yield delay(200);
  try {
    const response = yield call(giftCardApis.giftCard.getDetail, payload);
    yield put(actions.async.getGiftCardDetail.success(response.data.data));
  } catch (error) {
    yield put(actions.async.getGiftCardDetail.fail({}));
  }
};

const getGiftCardSummary: ISagaFunc = function* () {
  yield delay(200);
  try {
    const response = yield call(giftCardApis.giftCard.getSummary);
    yield put(actions.async.getGiftCardSummary.success(response.data.data));
  } catch (error) {
    yield put(actions.async.getGiftCardSummary.fail({}));
  }
};

const getInitialCustomers: ISagaFunc = function* () {
  yield delay(200);
  try {
    const res: IResponseData<{ content: ISearchCustomerItem[] }> = yield call(giftCardApis.getInitialCustomers);
    if (res.data.data.content)
      yield put(actions.async.getInitialCustomers.success(res.data.data.content));
  } catch (error) {
    yield put(actions.async.getInitialCustomers.fail({}));
  }
};
export default function* sagas() {
  yield takeLatest(actions.async.getGiftCardList.fetch, getGiftCardList);
  yield takeLatest(actions.async.getGiftCardDetail.fetch, getGiftCardDetail);
  yield takeLatest(actions.async.getGiftCardSummary.fetch, getGiftCardSummary);
  yield takeLatest(actions.async.getInitialCustomers.fetch, getInitialCustomers);
}
